export const STATUS_PENDING = "A";
export const STATUS_SUCCESS = "B";
export const STATUS_FAILED = "C";
export const ALL_STATUS = [STATUS_PENDING, STATUS_SUCCESS, STATUS_FAILED];

export const TYPE_OUTPUT = "A";
export const TYPE_INPUT = "B";
export const TYPE_RESPONSE = "C";
